import { createStore } from 'vuex';
// import { GarmentDefaultDataClient, EstimationClient, CompanyManagerUserClient, EmployeeClient } from '@/services/Services';
import * as OM from '@/Model';

let store = {
    state: {
        showSpinner: 0,
        loggedUser: new OM.LoggedUserVM(),
        consts: {
            localizedValues: <OM.LocalizedEntity[]>[],
            enabledLanguages: <string[]>[],
        },
        selectedLanguage: "",
    },
    mutations: {
    },
    actions: {
    },
    modules: {
    },
    getters: {
    }
}

export default createStore(store);